import { useState, useEffect } from 'react'
import { useRouter } from 'next/router'
import {
  datalayerSimpleEvent,
  getSsoForgotPasswordUrl,
  useMobile,
  useUserWithMembership
} from '@smuchile/pkg-unimarc-hooks'
import { FIVE_MINUTES_OUTDATED_INFO } from '@smuchile/pkg-unimarc-hooks/shared/constants'
import {
  UpdatePasswordRequired,
  UpdatePasswordRequiredModal
} from '@smuchile/pkg-unimarc-components'

export const RequiredChangePasswordWrapper = () => {
  const router = useRouter()
  const forgotPasswordURL = getSsoForgotPasswordUrl('update')
  const [eventSent, setEventSent] = useState(false)

  const { isMobile } = useMobile()
  const { data } = useUserWithMembership({
    staleTime: FIVE_MINUTES_OUTDATED_INFO
  })

  const handleChangePassword = () => {
    datalayerSimpleEvent({
      event: 'password_update_modal_button',
      eventAction: 'clic'
    })

    //It is necessary to complete the tagging
    setTimeout(() => {
      router.push(forgotPasswordURL)
    }, 800)
  }

  useEffect(() => {
    if (!eventSent && data?.code === 'SEC-001') {
      datalayerSimpleEvent({
        event: 'password_update_modal',
        eventAction: 'view'
      })
      setEventSent(true)
    }
  }, [data?.code, eventSent])

  if (data?.code === 'SEC-001') {
    if (isMobile)
      return (
        <UpdatePasswordRequiredModal
          isMobile={true}
          isOpen={true}
          onClose={handleChangePassword}
        />
      )
    return <UpdatePasswordRequired onButtonClick={handleChangePassword} />
  }

  return null
}
